import * as React from 'react';
import {
    type Controlled_NumberInputProps,
} from '../../../../../../../react-commons/components/inputs/controlled/Controlled_NumberInput';
import { ControlledInputs } from '../../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { usePropertyInfo } from '../../../../hooks/usePropertyInfo';
import { type PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const Controlled_PropertyNumberInput = <N extends boolean>({
                                                                      labelOverride,
                                                                      propertyValidationInformation: {
                                                                          propertyIdentifier,
                                                                          resourceType,
                                                                          resourceId,
                                                                      },
                                                                      hideLabel,
                                                                      readOnly,
                                                                      ...props
                                                                  }: Omit<Controlled_NumberInputProps<N>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'endingIcon'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <ControlledInputs.Number
        {...propertyInfo}
        {...props}
        helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
    />;
};
